<template>
  <div class="card">
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-8">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-table"></i>
            TABLAS ARPU
          </p>
        </div>
        <div
          class="col-4"
          style="display: flex; justify-content: flex-end; align-items: center; gap: 10px"
        >
          <div @click="fetchTables" style="cursor: pointer">
            <i class="fas fa-sync text-sm opacity-10"></i>
          </div>
          <button class="btn btn-sm btn-primary" @click="openCreateModal">
            <i class="fas fa-plus"></i> Nueva tabla
          </button>
        </div>
      </div>

      <div v-if="loading" class="text-center py-4">
        <i class="fas fa-spinner fa-spin"></i> Cargando...
      </div>

      <div v-else class="table-responsive">
        <table class="table tablesorter">
          <thead class="thead-light">
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Rangos</th>
              <th>Default</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="table in tables" :key="table.id">
              <td>{{ table.name }}</td>
              <td>{{ table.description || "-" }}</td>
              <td>
                <span
                  v-for="(tier, idx) in table.tiers"
                  :key="idx"
                  class="badge bg-secondary me-1"
                  style="font-size: 11px"
                >
                  {{ tier.minSales }}-{{ tier.maxSales ?? "∞" }}:
                  {{ tier.rate }}x
                </span>
              </td>
              <td>
                <span v-if="table.isDefault" class="badge bg-success">Sí</span>
                <span v-else class="text-muted">No</span>
              </td>
              <td>
                <button
                  class="btn btn-sm btn-info me-1"
                  @click="openEditModal(table)"
                >
                  <i class="fas fa-edit"></i>
                </button>
                <button
                  class="btn btn-sm btn-danger"
                  :disabled="table.isDefault"
                  @click="deleteTable(table)"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="tables.length === 0">
              <td colspan="5" class="text-center text-muted">
                No hay tablas ARPU configuradas
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <VueFinalModal
      v-model="showModal"
      :esc-to-close="false"
      :click-to-close="false"
      class="modal-container"
      content-class="modal-content4"
    >
      <div class="modal-header">
        <h5 class="modal-title">
          {{ editingTable.id ? "Editar tabla ARPU" : "Nueva tabla ARPU" }}
        </h5>
        <button type="button" class="btn-close" @click="showModal = false"></button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <label>Nombre</label>
          <input
            type="text"
            class="form-control"
            v-model="editingTable.name"
            placeholder="Ej: Tabla CRESA"
          />
        </div>
        <div class="form-group mb-3">
          <label>Descripción (opcional)</label>
          <input
            type="text"
            class="form-control"
            v-model="editingTable.description"
          />
        </div>
        <div class="form-check mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="isDefaultCheck"
            v-model="editingTable.isDefault"
          />
          <label class="form-check-label" for="isDefaultCheck">
            Tabla por defecto (para distribuidores sin asignación)
          </label>
        </div>

        <h6>Rangos de ventas</h6>
        <p class="text-muted" style="font-size: 12px">
          El último rango debe dejarse sin ventas máximas (infinito).
        </p>

        <div
          v-for="(tier, index) in editingTable.tiers"
          :key="index"
          class="row mb-2 align-items-end"
        >
          <div class="col-3">
            <label class="form-label" style="font-size: 12px">Ventas mín</label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model.number="tier.minSales"
              min="1"
            />
          </div>
          <div class="col-3">
            <label class="form-label" style="font-size: 12px">Ventas máx</label>
            <input
              type="number"
              class="form-control form-control-sm"
              v-model.number="tier.maxSales"
              :placeholder="index === editingTable.tiers.length - 1 ? '∞' : ''"
              :disabled="index === editingTable.tiers.length - 1"
            />
          </div>
          <div class="col-3">
            <label class="form-label" style="font-size: 12px">Multiplicador</label>
            <input
              type="number"
              step="0.1"
              class="form-control form-control-sm"
              v-model.number="tier.rate"
              min="0.1"
            />
          </div>
          <div class="col-3">
            <button
              v-if="editingTable.tiers.length > 1 && index !== editingTable.tiers.length - 1"
              class="btn btn-sm btn-outline-danger"
              @click="removeTier(index)"
            >
              <i class="fas fa-minus"></i>
            </button>
          </div>
        </div>

        <button class="btn btn-sm btn-outline-primary mt-2" @click="addTier">
          <i class="fas fa-plus"></i> Agregar rango
        </button>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="showModal = false">
          Cancelar
        </button>
        <button class="btn btn-primary" :disabled="saving" @click="saveTable">
          <i v-if="saving" class="fas fa-spinner fa-spin me-1"></i>
          Guardar
        </button>
      </div>
    </VueFinalModal>
  </div>
</template>

<script>
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";

const EMPTY_TIER = { minSales: 1, maxSales: 5, rate: 1 };

export default {
  name: "TablasArpu",
  components: { VueFinalModal },
  data() {
    return {
      loading: true,
      saving: false,
      tables: [],
      showModal: false,
      userId: this.$store.state.user.userId,
      tokenAuth: this.$store.state.tokenAuth,
      editingTable: {
        id: null,
        name: "",
        description: "",
        isDefault: false,
        tiers: [{ ...EMPTY_TIER }, { minSales: 6, maxSales: null, rate: 2 }],
      },
    };
  },
  mounted() {
    this.fetchTables();
  },
  methods: {
    fetchTables() {
      this.loading = true;
      this.$https
        .post("/administration/fetchArpuTables", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((res) => {
          this.tables = res.data.tables || [];
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.error(
            error.response?.data?.message || "Error al cargar tablas ARPU",
            { position: "top-right", max: 10 },
          );
        });
    },

    openCreateModal() {
      this.editingTable = {
        id: null,
        name: "",
        description: "",
        isDefault: false,
        tiers: [
          { minSales: 1, maxSales: 5, rate: 1 },
          { minSales: 6, maxSales: 12, rate: 2 },
          { minSales: 13, maxSales: 20, rate: 2.5 },
          { minSales: 21, maxSales: null, rate: 3 },
        ],
      };
      this.showModal = true;
    },

    openEditModal(table) {
      this.editingTable = {
        id: table.id,
        name: table.name,
        description: table.description || "",
        isDefault: table.isDefault || false,
        tiers: table.tiers.map((t) => ({
          minSales: t.minSales,
          maxSales: t.maxSales,
          rate: t.rate,
        })),
      };
      this.showModal = true;
    },

    addTier() {
      const tiers = this.editingTable.tiers;
      const last = tiers[tiers.length - 1];
      if (last) {
        last.maxSales = last.minSales + 4;
      }
      tiers.push({
        minSales: last ? last.maxSales + 1 : 1,
        maxSales: null,
        rate: (last?.rate || 1) + 0.5,
      });
    },

    removeTier(index) {
      this.editingTable.tiers.splice(index, 1);
      const tiers = this.editingTable.tiers;
      if (tiers.length > 0) {
        tiers[tiers.length - 1].maxSales = null;
      }
    },

    saveTable() {
      if (!this.editingTable.name?.trim()) {
        this.$toast.warning("El nombre es obligatorio", {
          position: "top-right",
          max: 10,
        });
        return;
      }

      const tiers = this.editingTable.tiers.map((t, i, arr) => ({
        minSales: Number(t.minSales),
        maxSales: i === arr.length - 1 ? null : Number(t.maxSales),
        rate: Number(t.rate),
      }));

      this.saving = true;
      this.$https
        .post("/administration/saveArpuTable", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          table: {
            id: this.editingTable.id,
            name: this.editingTable.name.trim(),
            description: this.editingTable.description,
            isDefault: this.editingTable.isDefault,
            groupingMode: "distributor_month",
            tiers,
          },
        })
        .then(() => {
          this.saving = false;
          this.showModal = false;
          this.$toast.success("Tabla ARPU guardada", {
            position: "top-right",
            max: 10,
          });
          this.fetchTables();
        })
        .catch((error) => {
          this.saving = false;
          this.$toast.error(
            error.response?.data?.message || "Error al guardar tabla",
            { position: "top-right", max: 10 },
          );
        });
    },

    deleteTable(table) {
      this.$swal({
        title: "¿Eliminar tabla?",
        text: `¿Deseas eliminar "${table.name}"? Solo es posible si ningún distribuidor la usa.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (!result.isConfirmed) return;

        this.$https
          .post("/administration/deleteArpuTable", {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            tableId: table.id,
          })
          .then(() => {
            this.$toast.success("Tabla eliminada", {
              position: "top-right",
              max: 10,
            });
            this.fetchTables();
          })
          .catch((error) => {
            this.$toast.error(
              error.response?.data?.message || "Error al eliminar tabla",
              { position: "top-right", max: 10 },
            );
          });
      });
    },
  },
};
</script>
